import styled, { css } from 'styled-components';

interface IBackgroundColor {
  color: any;
}

export const Container = styled.button<IBackgroundColor>`
  padding: 0 1.5rem;
  height: 50px;

  width: 100%;

  background-color: var(--blue);
  color: var(--white);

  ${(props) =>
    props.color === 'white' &&
    css`
      background-color: var(--white);
      color: var(--blue);
    `};

  border-radius: 0.25rem;
  border: 0;

  transition: filter 0.2s;

  font-size: 1rem;
  font-weight: 500;

  &:hover {
    filter: brightness(0.9);
  }
`;
